export default "__VITE_ASSET__kQVxiyUE__"